<ng-container [ngSwitch]="sample?.objectType?.toLowerCase()">
  <gen-dynamic-specimen *ngSwitchCase="'dynamic'"
                        [disabledForced]="disabledForced || !allowedit" [editMode]="editMode"
                        [index]="index"
                        [sample]="sample"
                        [formId]="sample?.config?.formId"
                        [overrides]="overrides[sample?.config?.formId]"
                        [contextReferences]="changedFieldsReferences"
                        [sampleType]="sample.sampleType"
                        [markAsPrimaryEnabled]="markAsPrimaryEnabled"
                        [proceedToAnaliseStarted]="proceedToAnaliseStarted"
                        [title]="sample?.config?.title"
                        (OnCallback)="onUpdate($event)"
                        (OnPrimarySet)="onPrimarySet($event)"
  ></gen-dynamic-specimen>
  <gen-navican-sample *ngSwitchCase="'navican'"
                      [disabledForced]="disabledForced"
                      [allowedit]="allowedit"
                      [index]="index"
                      [sample]="sample"
                      [collections]="testService?.testInfoCollections"
                      [updatedFields]="diffFields"
                      (callback)="onUpdate($event)"
  ></gen-navican-sample>
  <gen-normal-specimen *ngSwitchCase="'normal'"
                       [disabledForced]="disabledForced"
                       [allowedit]="allowedit"
                       [index]="index"
                       [sample]="sample"
                       [collections]="testService?.testInfoCollections"
                       [updatedFields]="diffFields"
                       (callback)="onUpdate($event)"
  ></gen-normal-specimen>
  <gen-tumor-specimen *ngSwitchCase="'tumor'"
                      [disabledForced]="disabledForced"
                      [allowedit]="allowedit"
                      [index]="index"
                      [sample]="sample"
                      [collections]="testService?.testInfoCollections"
                      [updatedFields]="diffFields"
                      (callback)="onUpdate($event)"
  ></gen-tumor-specimen>
</ng-container>
